/**
 * Manually created routes file for easier access
 */

export const Routes = {
  index: 'index',
  admin: 'admin',
  admin_user_management: 'admin-user-management',
  storage_debug: 'storage-debug',
  user_management: 'user-management',
  user_manual_files: 'user-manual-files',
  _websocket: 'websocket',

  // Auth
  auth_login: 'auth-login',
  auth_register: 'auth-register',
  auth_saml_jwt: 'auth-saml-jwt',

  // HAnS
  hans: 'hans',
  activity: 'hans-activity',
  activity_network: 'hans-activity-network',
  activity_switching_premises: 'hans-activity-switching-premises',
  activity_switchings: 'hans-activity-switchings',
  activity_switching_blocks: 'hans-activity-switching-blocks',
  activity_switchings_gantt: 'hans-activity-switchings-gantt',
  activity_equipments: 'hans-activity-equipments',
  activity_projects: 'hans-activity-projects',
  activity_subprojects: 'hans-activity-subprojects',
  activity_topologies: 'hans-activity-topologies',
  activity_compare: 'hans-activity-compare',
  activity_report: 'hans-activity-report',
  activity_report_switchings: 'hans-activity-report-switchings',
  activity_report_switchings_gantt: 'hans-activity-report-switchings-gantt',
  activity_report_front_matter: 'hans-activity-report-front-matter',
  activity_report_network_topologies: 'hans-activity-report-network-topologies',
  activity_report_network_state: 'hans-activity-report-network-state',
  activity_report_network_equipment_status: 'hans-activity-report-network-equipment-status',
  activity_report_topologies_matrix: 'hans-activity-report-topologies-matrix',

  // SINA
  sina: 'sina',
  sina_survey: 'sina-survey',
  sina_survey_job_cluster: 'sina-survey-job-cluster',
  sina_survey_switching_windows: 'sina-survey-switching-windows',
  sina_survey_results_index: 'sina-survey-results',
  sina_survey_results_nnf_cne_table: 'sina-survey-results-nnf-cne-table',
  sina_survey_results_timeline: 'sina-survey-results-timeline',
} as const
